<!-- <products-related [productsTags]="'promodashboard'" [layout]="'cards'"></products-related> -->
 
<div class="container-fluid px--0 py--lg-48 py--24" isInVewport (isInViewport)="onVisibilityChanged('titleIntro',$event)" [threshold]="0.1">
    <div [@fadeInUp]="{value: visibilityState['titleIntro'], params: {delay: '0ms'}}" (@fadeInUp.done)="onVisibilityChanged('relatedSection',true)">
        <app-section-title   [title]="'page.dashboard-dynamic.products-related.title' | translate" [subtitle]="'page.dashboard-dynamic.products-related.description' | translate" [sectionclass]="'container mb--lg-48 mb--24 text-center'"></app-section-title>
    </div>
    <div class="container d-flex flex-column gap-64 " *ngIf="!loading$() && productsRelated && productsRelated?.length; else loading">
        <ng-container *ngFor="let product of productsRelated; let i = index">
            <ng-container *ngIf="product.sku === 'obiettivo-europa'; else productCard">
                    <div [@fadeInUp]="{value: visibilityState['relatedSection'], params: {delay: '500ms'}}">
                        <ng-container *ngTemplateOutlet="productOe; context: {$implicit: product}"></ng-container>
                    </div>
            </ng-container>
        <ng-template #productCard>
            <div [@fadeInUp]="{value: visibilityState['relatedSection'], params: {delay: '500ms'}}">
                <product-related-card [item]="product"  ></product-related-card>
            </div>
            </ng-template>
        </ng-container>
    </div>
</div>
 <ng-template #productOe let-product>
    <section class="products-promo">
        <div class="d-flex flex-lg-row flex-column gap-24 place-content-center">
            <div class="button-product active col-12 col-lg-6">
                <app-obiettivo-europa-list [filters]="false" [layout]="'carousel'"/>
            </div>
            <div class="col-12 col-lg-6 p--0 d-flex flex-column align-items-start justify-content-center">
                <div class="product-icon mb--24" *ngIf= "product.thumb_url">
                    <img [ngSrc]="product.thumb_url" width="56" height="56" [attr.alt]="'products-overview'" priority>
                </div>
                <h3 class="promo-section-title">{{ product.promo_title ? product.promo_title : product.name }}</h3>
                <div class="promo-description mb--24" [innerHTML]=" product.promo_box ? product.promo_box : product.description"></div>
                <button mat-stroked-button color="primary" (click)="clickOeAction(product)">Scopri di più</button>
            </div>
        </div>
    </section>
</ng-template>
<ng-template #loading>
    <div class="container">
        <ngx-mare-skeleton [grid]="'3x1'"></ngx-mare-skeleton>
    </div>
</ng-template>